/* unplugin-vue-components disabled */import { render } from "./TaiChiBRender.vue?vue&type=template&id=0ae14cdf&scoped=true"
import script from "./TaiChiBRender.vue?vue&type=script&lang=js"
export * from "./TaiChiBRender.vue?vue&type=script&lang=js"

import "./TaiChiBRender.vue?vue&type=style&index=0&id=0ae14cdf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae14cdf"]])

export default __exports__